import TableData, { TableColumn } from "./TableData";

class TableDataBuilder {
    static newTableData(data) {
        return new TableDataBuilder(data);
    }

    data = [];
    columns = [];
    rowId = null;
    selection = [];

    constructor(data = []) {
        this.data = data;
    }
    addColumn(accessor, label, options = {}) {
        const column = new TableColumn(accessor, label, options);
        this.columns.push(column);
        return this;
    }
    addColumns(...accessors) {
        accessors.forEach(accessor => this.addColumn(accessor));
        return this;
    }
    withRowId(rowId) {
        this.rowId = rowId;
        return this;
    }
    withSelection(selection) {
        this.selection = selection;
        return this;
    }
    build() {
        const {data, columns, rowId, selection} = this;
        const tableData = new TableData(data, columns, { rowId, selection });
        return tableData;
    }
}

export default TableDataBuilder;